import { render, staticRenderFns } from "./midheader.vue?vue&type=template&id=f1f716c4"
import script from "./midheader.vue?vue&type=script&lang=js"
export * from "./midheader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TfHeaderEplusSocials: require('/usr/src/app/components/tf/header/eplus/socials.vue').default})
